import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericHttpResponse } from '../../../../../shared/services/interfaces/generic-http-response.interface';
import { HttpCommonService } from '../../../../../shared/services/http-common.service';
import {
  ContactoAdministrativo,
  ContactoAdministrativoPayload,
  ContactoAdministrativoPaginatedResponse
} from './contactos-administrativos.interface';

export interface ContactoAdministrativoFilters {
  cli_cliente_id: number;
  cli_establecimiento_id?: number;
  page?: number;
  per_page?: number;
  search?: string;
  activo?: string;
  origen?: string;
  param_establecimiento_tipo_contacto_id?: string;
}

@Injectable({ providedIn: 'root' })
export class ContactosAdministrativosService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  index(
    filters: ContactoAdministrativoFilters
  ): Observable<GenericHttpResponse<ContactoAdministrativoPaginatedResponse>> {
    const url = this.httpCommonService.makeUrl('/clie/establecimientosContactos', filters);
    return this.http.get<GenericHttpResponse<ContactoAdministrativoPaginatedResponse>>(url);
  }

  show(id: number): Observable<GenericHttpResponse<ContactoAdministrativo>> {
    const url = this.httpCommonService.makeUrl(`/clie/establecimientosContactos/${id}`);
    return this.http.get<GenericHttpResponse<ContactoAdministrativo>>(url);
  }

  store(
    body: ContactoAdministrativoPayload
  ): Observable<GenericHttpResponse<ContactoAdministrativo>> {
    const url = this.httpCommonService.makeUrl('/clie/establecimientosContactos');
    return this.http.post<GenericHttpResponse<ContactoAdministrativo>>(url, body);
  }

  update(
    id: number,
    body: ContactoAdministrativoPayload
  ): Observable<GenericHttpResponse<ContactoAdministrativo>> {
    const url = this.httpCommonService.makeUrl(`/clie/establecimientosContactos/${id}`);
    return this.http.put<GenericHttpResponse<ContactoAdministrativo>>(url, body);
  }

  destroy(id: number): Observable<GenericHttpResponse<any>> {
    const url = this.httpCommonService.makeUrl(`/clie/establecimientosContactos/${id}`);
    return this.http.delete<GenericHttpResponse<any>>(url);
  }
}
